// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__TK8ml","large":"styles_large__29wy6"};